(function() {
	'use strict';

	angular
		.module('app.setup')
		.controller('projectCustomFields', projectCustomFields);

	projectCustomFields.$inject = ['$rootScope', '$scope', '$timeout', '$compile', '$uibModal', 'projectCustomFieldsService', 'VIEW_PROJECTS', 'storeService'];

	function projectCustomFields($rootScope, $scope, $timeout, $compile, $uibModal, projectCustomFieldsService, VIEW_PROJECTS, storeService) {
		var vm = this;
		var adminConfig = storeService.getState().adminConfig;
		vm.projectCustomFields = [];
		vm.addField = addField;
		vm.showDropDownFieldValues = showDropDownFieldValues;
		vm.deleteField = deleteField;
		vm.startEdit = startEdit;
		vm.cancelEdit = cancelEdit;
		vm.fieldTypes = {
			'TEXT' : 'Text Field',
			'TEXTAREA': 'Text Area',
			'DATE': 'Date Field',
			'NUMBER': 'Number Field',
			'CURRENCY': 'Currency Field',
			'DROPDOWN': 'Drop-Down'
		};

		activate();

		function activate() {
			getCustomFields();
		}

		function getCustomFields() {
			projectCustomFieldsService.getCustomFields(adminConfig.customer.id).then(function(response){
				var projectCustomFields = response;
				if (projectCustomFields.data && projectCustomFields.data.length) {
					vm.projectCustomFields = projectCustomFields.data;
				} else {
					vm.projectCustomFields = [];
				}
			});
		}
		
		function addField() {
			var customFieldFormScope = $scope.$new();
			var opts = {
				scope: customFieldFormScope,
				templateUrl: '/application/f/setup/projects/customFields/addFieldForm/add-field.html',
				size: 'sm',
				backdrop: 'static',
				windowClass: 'custom-field-modal'
			};

			var instance = $uibModal.open(opts);
			customFieldFormScope.closeDialog = function() {
				instance.close();
				customFieldFormScope.$destroy();
			};

			customFieldFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				if (isSuccessful) {
					getCustomFields();
				}
				if (isSuccessful || message === '') {
					instance.close();
					customFieldFormScope.$destroy();
				}
			};
		}
		
		function showDropDownFieldValues(customField) {
			var customFieldFormScope = $scope.$new();
			customFieldFormScope.customFieldNdx = customField.ndx;
			customFieldFormScope.customFieldName = customField.name;
			var opts = {
				scope: customFieldFormScope,
				templateUrl: '/application/f/setup/projects/customFields/dropdownFieldValues/dropdown-values.html',
				size: 'sm',
				backdrop: 'static'
			};

			var instance = $uibModal.open(opts);
			customFieldFormScope.closeDialog = function() {
				instance.close();
				customFieldFormScope.$destroy();
			};

			customFieldFormScope.result = function(message, isSuccessful) {
				$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
				instance.close();
				customFieldFormScope.$destroy();
			};
		}
		
		function loadList() {
			if (vm.dropdownLists && vm.dropdownLists.length) {
				return;
			} else {
				vm.dropdownLists = [{id:'ENABLED', display: 'Enabled'},
					{id:'DISABLED', display: 'Disabled'}
				];
			}
		}
		
		function getTemplate(position, rowIndex, fieldInputType, fieldName) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			var divHeight = 112;
			var extraClass = 'textEdit';
			if (fieldInputType === 'textArea') {
				divHeight = 348;
				extraClass = ' textAreaEdit description-area';
			}
			if (position.left + 296 > windowWidth) {
				position.left = position.left - (position.left + 296 - windowWidth - 8);
			}
			if (position.top + divHeight > windowHeight) {
				position.top = position.top - (position.top + divHeight - windowHeight - 8);
			}
			var header = 'Edit ' + fieldName;
			var scopeModal = 'customFieldsCtrl.editFieldValue';
			
			var editTemplate = '<div class="inlineEditDiv ' + extraClass + '" style="top:' + position.top + 'px; left: ' +
				position.left + 'px;"><div class="inlineEditHeader">' + header + '</div>' +
				'<span id="errorMsg" style="color:red;" class="hide"></span>' +
				(fieldInputType === 'textArea' ? '<textarea class="inlineEditInput" ng-model="' + scopeModal + '"></textarea>' : '<input class="inlineEditInput" ng-model="' + scopeModal + '" />') +
				'<div class="inlineEditButtons"><a class="button flat" ng-click="customFieldsCtrl.cancelEdit()">Cancel</a>' +
				'<a class="button flat colored" ng-click="(' + scopeModal + ' && ' + scopeModal + '.length>0) && ' + 'customFieldsCtrl.saveEdit(' + rowIndex + ', \'' +  fieldName + '\')">Save</a></div></div>';
			return editTemplate;
		}
		
		function getListTemplate(position, index, fieldId, label, id, display) {
			var windowWidth = window.innerWidth;
			var windowHeight = window.innerHeight;
			if (position.left + 340 > windowWidth) {
				position.left = position.left - (position.left + 340 - windowWidth - 8);
			}
			if (position.top + 356 > windowHeight) {
				position.top = position.top - (position.top + 356 - windowHeight - 8);
			}

			var editTemplate = '<div ng-click="$event.preventDefault();" class="inlineEditDiv textEdit" style="top:' + position.top + 'px; left: ' + position.left + 'px;">' +
				'<div class="inlineEditHeader">Choose ' + label + '</div>' +
				'<ui-select append-to-body="false" theme="bootstrap" ng-model="customFieldsCtrl.editFieldValue">' +
				'<ui-select-match placeholder="{{\'Select ' + label + '...\'' + ' | translate}}">' +
				'{{$select.selected.' + display + '}}' +
				'</ui-select-match>' +
				'<ui-select-choices repeat="item.' + id + ' as item in customFieldsCtrl.dropdownLists | filter: $select.search">' +
				'<div>{{item.' + display + '}}</div>' +
				'</ui-select-choices>' +
				'</ui-select>' +
				'<div class="inlineEditButtons">' +
				'<button class="button flat" ng-click="customFieldsCtrl.cancelEdit()">Cancel</button>' +
				'<button class="button flat colored" ng-click="customFieldsCtrl.saveEdit(' + index + ', \'' +  fieldId + '\')">Save</button>' +
				'</div>' +
				'</div>';
			return editTemplate;
		}
		
		function startEdit($customField, fieldName, index, fieldType, id, display) {
			if (jQuery('.inlineEditDiv').length) {
				jQuery('.inlineEditDiv').unbind();
				jQuery('.inlineEditDiv').remove();
			}
			var cell = jQuery('#' + fieldName + index);
			var pos = cell.offset();

			var rowIndex = vm.projectCustomFields.indexOf($customField);
			var content = vm.projectCustomFields[rowIndex][fieldName];
			var editTemplate = fieldType == 'list' ? getListTemplate(pos, rowIndex, fieldName, fieldName, id, display) : getTemplate(pos, rowIndex, fieldType, fieldName);
			loadList();
			
			var compiledDiv = $compile(editTemplate)($scope);
			vm.editFieldValue = content;
			jQuery('#customFields').append(compiledDiv);
			compiledDiv.keyup(function(event) {
				var code = event.keyCode || event.which;
				if (code == 13) {
					if (vm.editFieldValue == null || strip(vm.editFieldValue) === '') {
						return;
					}
					vm.saveEdit(rowIndex, fieldName);
				} else if (code == 27) {
					vm.cancelEdit();
				}
			});
			
			jQuery('.inlineEditDiv input').focus();
			vm.inlineActive = true;
		};

		
		function cancelEdit() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
		};

		vm.saveEdit = function(index, fieldName) {
			var content = strip(vm.editFieldValue);	
			var saveObj = {};
			saveObj.ndx = vm.projectCustomFields[index].ndx;
			var tempField = vm.projectCustomFields[index][fieldName];
			
			if (tempField != content) {
				saveObj[fieldName] = content;
				if (fieldName === 'name') {
					if (_.indexOf(VIEW_PROJECTS.NATIVE_COLUMNS_NAME, content) >= 0) {
						jQuery('.inlineEditDiv').hide();
						var messageScope = $scope.$new();
						messageScope.messageTitle = 'Alert';
						messageScope.messageText = '"' + content + '" is a field name reserved by the system and already ' +
							'exists for every project by default. Please choose a different name.';
						messageScope.buttonText = 'Close';

						var opts = {
							scope: messageScope,
							templateUrl: '/application/f/core/message.html'
						};

						var instance = $uibModal.open(opts);
						messageScope.yes = function() {
							jQuery('.inlineEditDiv').show();
							instance.close();
							messageScope.$destroy();
						};
					} else {
						update_field(saveObj, index, fieldName);
						hide_field_edit_box();
					}
					return;
				} else {
					update_field(saveObj, index, fieldName);
				}
			}
			hide_field_edit_box();
		};

		function hide_field_edit_box() {
			jQuery('.inlineEditDiv').unbind();
			jQuery('.inlineEditDiv').remove();
			vm.inlineActive = false;
			vm.cancelEdit();
		}

		function update_field(saveObj, index, fieldName) {
			projectCustomFieldsService.updateCustomField(saveObj, (new Date(vm.projectCustomFields[index].lastModified)).toUTCString(), adminConfig.customer.id)
				.then(function(response) {
					if (response && response.status && response.status >= 200 && response.status < 400) {
						$rootScope.$emit('toast', {'message': 'Custom Field ' + fieldName + ' was saved successfully', 'success': true});
						getCustomFields();
					} else if (response.status === 400) {
						var errorMessage = 'Custom field limit exceeded.';
						if (response && response.data && response.data.error) {
							errorMessage = response.data.error;
						}
						$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
					} else if (response.status === 409) {
						var errorMessage = 'Custom field name already exists.';
						if (response && response.data && response.data.error) {
							errorMessage = response.data.error;
						}
						$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
					} else if (response && response.status === 412) {
						var errorMessage = 'This custom field has been updated since you last loaded the page, please refresh the page';
						if (response && response.data && response.data.error) {
							errorMessage = response.data.error;
						}
						$rootScope.$emit('toast', {'message': errorMessage, 'success': false});
					} else {
						$rootScope.$emit('toast', {'message': 'Unexpected server error', 'success': false});
					}
				});
		}

		function deleteField(fieldNdx) {
			var confirmScope = $scope.$new();
			confirmScope.fieldNdx = fieldNdx;
			confirmScope.additionalText = 'delete this custom field';
			confirmScope.buttonText = 'Delete';
			var opts = {
				scope: confirmScope,
				templateUrl: '/application/f/core/confirm.html'
			};

			var instance = $uibModal.open(opts);
			confirmScope.closeDialog = function() {
				instance.close();
				confirmScope.$destroy();
			};

			confirmScope.yes = function() {
				var fieldNdx = confirmScope.fieldNdx;
				instance.close();
				confirmScope.$destroy();
				projectCustomFieldsService.deleteCustomField(fieldNdx, adminConfig.customer.id).then(function(message) {
					var isSuccessful = (message == 'Custom field deleted successfully');
					$rootScope.$emit('toast', {'message': message, 'success': isSuccessful});
					if (isSuccessful) {
						getCustomFields();
					}
				});
			};
		}
	}
})();
